import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { PRE2022_SOURCES, Pre2022Source } from "@/services/xeroApi";

export default function XeroPre2022SourceCell({
  draft,
  tenantName,
  isPending,
  onDraftChange,
}: {
  draft: Pre2022Source | null;
  tenantName: string;
  isPending: boolean;
  onDraftChange: (next: Pre2022Source) => void;
}) {
  return (
    <Select
      value={draft ?? undefined}
      onValueChange={(next) => onDraftChange(next as Pre2022Source)}
      disabled={isPending}
    >
      <SelectTrigger
        className="h-8 w-full"
        aria-label={`Pre-2022 source for ${tenantName}`}
      >
        <SelectValue placeholder="Select a source" />
      </SelectTrigger>
      <SelectContent>
        {PRE2022_SOURCES.map((source) => (
          <SelectItem key={source} value={source}>
            {source}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
